import { render, staticRenderFns } from "./privacyPage.vue?vue&type=template&id=00f46c33&scoped=true&"
import script from "./privacyPage.vue?vue&type=script&lang=js&"
export * from "./privacyPage.vue?vue&type=script&lang=js&"
import style0 from "./privacyPage.vue?vue&type=style&index=0&id=00f46c33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f46c33",
  null
  
)

export default component.exports